import { camelize } from '@ember/string';
import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type Agreement from 'invite-sign/models/agreement';

export default class NdaSignature extends Model {
  declare [Type]: 'nda-signature';

  @belongsTo('agreement', { async: true, inverse: 'signature' }) declare agreement: AsyncBelongsTo<Agreement>;

  @attr() declare signature: unknown;

  toJSON(): Record<string, unknown> {
    const {
      data: { attributes },
    } = <{ data: { attributes: Record<string, unknown> } }>this.serialize();

    return Object.entries(attributes).reduce<Record<string, unknown>>((carry, [key, value]) => {
      carry[camelize(key)] = value;

      return carry;
    }, {});
  }
}
